import React from 'react'
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom'

import OrderList from './order-list'
import OrderDetail from './order-detail'
import OrderSearch from './order-search'
import LookAround from './look-around'
import OrderConfirm from './order-confirm'

export default function MobileService() {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route
        exact
        path={`${path}`}
        render={() => <Redirect to={`${path}/list`}></Redirect>}
      ></Route>
      <Route exact path={`${path}/list`}>
        <OrderList></OrderList>
      </Route>
      <Route exact path={`${path}/detail/:orderId`}>
        <OrderDetail></OrderDetail>
      </Route>
      <Route exact path={`${path}/confirm/:orderId`}>
        <OrderConfirm></OrderConfirm>
      </Route>
      <Route exact path={`${path}/search`}>
        <OrderSearch></OrderSearch>
      </Route>
      <Route exact path={`${path}/around/:orderId`}>
        <LookAround></LookAround>
      </Route>
    </Switch>
  )
}
